<template>
  <div class="no-expenses margin-top text-center">
    <img
      width="150"
      class="my-40"
      :src="RECEIPT_ICON"
      alt="No expenses"
    />
    <h4 class="text-muted my-0">There are no expenses</h4>
  </div>
</template>
<script>
import { RECEIPT_ICON } from '~/rails_assets';

export default {
  data() {
    return {
      RECEIPT_ICON,
    };
  },
};
</script>
